import chinese3dImage from '@/assets/mock/style/3D国风.png';
import q3dImage from '@/assets/mock/style/Q版3D.png';
import qFlatImage from '@/assets/mock/style/扁平几何.png';
import pastelSoftImage from '@/assets/mock/style/粉彩柔雾.png';
import chineseAnimationImage from '@/assets/mock/style/国风动画.jpeg';
import cartoonSimpleImage from '@/assets/mock/style/卡通简约.png';
import crayonDoodleImage from '@/assets/mock/style/蜡笔涂鸦.png';
import clayStopMotionImage from '@/assets/mock/style/黏土定格.png';
import paperCollageImage from '@/assets/mock/style/拼贴纸艺.jpeg';
import japaneseHandDrawnImage from '@/assets/mock/style/日式手绘.jpeg';
import forestFairyTaleImage from '@/assets/mock/style/森林童话.png';
import watercolorFairyTaleImage from '@/assets/mock/style/水彩童话.jpeg';
import inkChineseImage from '@/assets/mock/style/水墨国风.jpeg';
import oilImpastoImage from '@/assets/mock/style/油画厚涂.png';

export interface CharacterArtStyleItem {
  value: string;
  label: string;
  mobileLabel: string;
  image: string;
}

export const CHARACTER_NO_STYLE_VALUE = 'none';
export const CHARACTER_DEFAULT_ART_STYLE = '国风动画';

/** 与 Create.vue 绘本风格保持一致；预览图按风格名映射 mock/style */
export const CHARACTER_ART_STYLES: CharacterArtStyleItem[] = [
  {
    value: '国风动画',
    label: '国风动画',
    mobileLabel: '国风',
    image: chineseAnimationImage
  },
  {
    value: '水彩童话',
    label: '水彩童话',
    mobileLabel: '水彩',
    image: watercolorFairyTaleImage
  },
  {
    value: '蜡笔涂鸦',
    label: '蜡笔涂鸦',
    mobileLabel: '蜡笔',
    image: crayonDoodleImage
  },
  {
    value: '卡通简约',
    label: '卡通简约',
    mobileLabel: '卡通',
    image: cartoonSimpleImage
  },
  {
    value: '拼贴纸艺',
    label: '拼贴纸艺',
    mobileLabel: '拼贴',
    image: paperCollageImage
  },
  {
    value: '水墨国风',
    label: '水墨国风',
    mobileLabel: '水墨',
    image: inkChineseImage
  },
  {
    value: '国风3D',
    label: '国风3D',
    mobileLabel: '国风3D',
    image: chinese3dImage
  },
  {
    value: '森林童话',
    label: '森林童话',
    mobileLabel: '森林',
    image: forestFairyTaleImage
  },
  {
    value: '扁平几何',
    label: '扁平几何',
    mobileLabel: '扁平',
    image: qFlatImage
  },
  {
    value: '粉彩柔雾',
    label: '粉彩柔雾',
    mobileLabel: '粉彩',
    image: pastelSoftImage
  },
  {
    value: '日式手绘',
    label: '日式手绘',
    mobileLabel: '日式',
    image: japaneseHandDrawnImage
  },
  {
    value: 'Q版3D',
    label: 'Q版3D',
    mobileLabel: 'Q版3D',
    image: q3dImage
  },
  {
    value: '油画厚涂',
    label: '油画厚涂',
    mobileLabel: '油画',
    image: oilImpastoImage
  },
  {
    value: '黏土定格',
    label: '黏土定格',
    mobileLabel: '黏土',
    image: clayStopMotionImage
  }
];
